// extracted by mini-css-extract-plugin
export default {"tableContainer":"Wu0801cHiHtm8Eg4iGLv"};